import styled from 'styled-components';

export const RequirementCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-50);
  align-items: flex-start;
`;

export const BetweenItemCountWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
